import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipping-labels',
  templateUrl: './shipping-labels.component.html',
  styleUrls: ['./shipping-labels.component.css']
})
export class ShippingLabelsComponent implements OnInit {
  public loading = false;
  public labels: Array<any> = [];
  public store: any = {};
  public user: any = {};
  public userDetails: any;
  public fallbackImage: string = 'assets/img/label-not-found.jpg';

  constructor() { }

  ngOnInit() {
    if (localStorage.getItem('storeLabelData')) {
      const storeLabelData = JSON.parse(localStorage.getItem('storeLabelData'));
      this.labels = storeLabelData.labels;
      this.store = storeLabelData.store;
      this.user = storeLabelData.user;
      this.userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : {};
    }
  }

  printInvoice() {
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  // Assign a product-image when mockup is not available
  getMockupImage(mockupData: any, projectIndex: any, order: any){
    let imageUrl: string = '';
    if(mockupData){
      if(mockupData[projectIndex]){
        const mockupDataItem = mockupData[projectIndex];
        const mockupKey = Object.keys(mockupDataItem)[0];
        if (mockupDataItem[mockupKey].mockup) {
          imageUrl = mockupDataItem[mockupKey].mockup
        }
      }
    }

    if(!imageUrl){
      if(order){
        if(order.product[0]){
          if(order.product[0].image){
            imageUrl = order.product[0].image;
          }
        }
      }
    }

    return imageUrl;
  }
  
  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.fallbackImage;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/shipping-labels/shipping-labels.component.ts